// extracted by mini-css-extract-plugin
export default {"panel":"style_panel__66pHy","board":"style_board__dv1Lk"};